import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Lock } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import './Header.css';

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const { isAuthenticated, logout } = useAuth();

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
    // Prevent body scroll when menu is open on mobile
    if (!menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  };

  const closeMenu = () => {
    setMenuOpen(false);
    document.body.style.overflow = '';
  };

  const handleLogout = () => {
    logout();
    closeMenu();
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <header className="header" data-testid="header">
      <div className="header-container">
        <button 
          className={`hamburger ${menuOpen ? 'active' : ''}`} 
          onClick={toggleMenu}
          aria-label="Menu"
          data-testid="hamburger-menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <div className="logo-group">
          <Link to="/" className="logo" onClick={closeMenu} data-testid="logo-link">
            <img 
              src="https://customer-assets.emergentagent.com/job_e5c77d79-ca13-402d-b554-25dcc110651b/artifacts/mj5brxa4_Logo%20Freiheitsmacher%20transparent.png" 
              alt="Die Freiheitsmacher Logo" 
              className="logo-image"
            />
          </Link>
          <div className="privacy-lock" tabIndex={0} aria-label="Datenschutz-Hinweis" data-testid="privacy-lock">
            <Lock size={16} strokeWidth={2.4} />
            <div className="privacy-tooltip" data-testid="privacy-tooltip">
              <strong>Datenschutz wird bei uns groß geschrieben.</strong>
              <span>Deine Daten sind bei uns sicher und werden niemals an Dritte weitergegeben.</span>
            </div>
          </div>
        </div>

        <nav className={`nav ${menuOpen ? 'active' : ''}`} data-testid="navigation">
          <Link 
            to="/" 
            className={`nav-link ${isActive('/') ? 'active' : ''}`} 
            onClick={closeMenu}
            data-testid="nav-startseite"
          >
            Startseite
          </Link>
          {isAuthenticated ? (
            <>
              <Link 
                to="/mitgliederbereich" 
                className={`nav-link ${isActive('/mitgliederbereich') ? 'active' : ''}`} 
                onClick={closeMenu}
                data-testid="nav-mitgliederbereich"
              >
                Mitgliederbereich
              </Link>
              <button 
                className="nav-link logout-btn" 
                onClick={handleLogout}
                data-testid="logout-button"
              >
                Abmelden
              </button>
            </>
          ) : (
            <Link 
              to="/login" 
              className={`nav-link nav-cta ${isActive('/login') ? 'active' : ''}`} 
              onClick={closeMenu}
              data-testid="nav-login"
            >
              Mitgliederbereich
            </Link>
          )}
          <Link 
            to="/impressum" 
            className={`nav-link ${isActive('/impressum') ? 'active' : ''}`} 
            onClick={closeMenu}
            data-testid="nav-impressum"
          >
            Impressum
          </Link>
        </nav>
      </div>
    </header>
  );
}

export default Header;
